<h2 class="title px-l text-center">{{data.title}}</h2>
<div class="px-l" [innerHTML]="data.body">
</div>
<div class="d-flex p-l jce">
  @if (error()) {
    <p class="text-danger" role="alert">{{ error() }}</p>
  }
  <button mat-flat-button color="primary" (click)="onAccept()" [disabled]="saving()">Ich stimme zu</button>
</div>
